import { getYearlySavingsPercent } from '../utils/planPricing';

// Monthly/Yearly switch shared by sign-up plan selection and Plan & billing.
// A labelled group of two aria-pressed buttons. The selected option is shown by a border and
// bold text as well as the fill, so it never relies on colour alone (WCAG 1.4.1).
export function BillingToggle({ value, onChange, label = 'Billing period' }) {
  const savings = getYearlySavingsPercent();
  const options = [
    { id: 'monthly', text: 'Monthly' },
    { id: 'yearly', text: 'Yearly', extra: `Save ${savings}%` },
  ];

  return (
    <div
      role="group"
      aria-label={label}
      className="flex w-full max-w-sm gap-1 rounded-full bg-[var(--plan-toggle-track)] p-1"
    >
      {options.map((option) => {
        const selected = value === option.id;
        return (
          <button
            key={option.id}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(option.id)}
            className={`mpg-focus-ring flex min-h-[48px] flex-1 items-center justify-center gap-2 rounded-full border-2 px-4 text-base text-[color:var(--plan-heading-text)] transition-colors ${
              selected
                ? 'border-[color:var(--plan-solo-text)] bg-[var(--plan-button)] font-bold'
                : 'border-transparent font-normal hover:bg-white/60'
            }`}
          >
            <span>{option.text}</span>
            {option.extra && (
              // Olive passes on the track (4.8:1) but not on sage (2.8:1), so go dark when selected.
              <span
                className={`text-sm font-bold ${
                  selected ? 'text-[color:var(--plan-heading-text)]' : 'text-[color:var(--plan-solo-text)]'
                }`}
              >
                {option.extra}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
